import { useEffect, useState } from 'react'
import { useLdReady } from './useLdReady'

/** Matches the initialisation timeout LdFeatureFlagProvider gives the LD client. */
const LD_READY_TIMEOUT_MS = 5_000

/**
 * `useLdReady`, bounded. `waitUntilReady()` settles when LD signals success or failure, but a request
 * that hangs signals neither, so an unbounded wait outlives the provider's own 5s timeout — anything
 * gated on it would stay on a spinner after LD has given up. Timing out treats the flags as they
 * read, which is off.
 */
export const useLdReadyWithTimeout = (): boolean => {
  const isLdReady = useLdReady()
  const [hasTimedOut, setHasTimedOut] = useState(false)

  useEffect(() => {
    if (isLdReady) return

    const timer = setTimeout(() => setHasTimedOut(true), LD_READY_TIMEOUT_MS)
    return () => clearTimeout(timer)
  }, [isLdReady])

  return isLdReady || hasTimedOut
}
